import React, { useEffect } from "react";
import "./DeviceAndTracking.css";
import MainLayout from "components/layout/main-layout/MainLayout";
import { titles } from "constants/titles";
import { ROUTES_CONSTANTS } from "routes/route-constants";
import SubscriberInformationCard from "components/layout/subscriber-information-card/SubscriberInformationCard";
import { RightFill } from "assets/SVGs/SVGs";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getAneltoTimeline,
  getClairvoyantTimeline,
  getDeviceList,
  getEviewTimeLine,
  getFreeusTimeline,
  setSelectedDeviceDetails,
} from "redux/Devices/actions";
import {
  GET_DEVICE_DETAILS,
  RESET_DEVICE_SYNC_LOG,
} from "redux/Devices/actionTypes";

const DeviceAndTracking = () => {
  const { deviceList, loading } = useSelector((store) => store?.devices);
  const { selectedMedicalUser } = useSelector(
    (store) => store?.medicalAlertUsers
  );
  const userData = useSelector((store) => store?.auth?.userData);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    getIntervals();
  }, []);

  const getIntervals = () => {
    const param = {
      dispatch,
      userType: userData?.isGuestUser ? "guestuser" : "accountowner",
      medical_alert_user_id: selectedMedicalUser?.medical_alert_user_id,
    };
    getDeviceList(param);
    getAneltoTimeline(param);
    getFreeusTimeline(param);
    getClairvoyantTimeline(param);
    getEviewTimeLine(param);
  };

  const onSeeDevicePress = (item) => {
    setSelectedDeviceDetails(dispatch, item);
    dispatch({
      type: GET_DEVICE_DETAILS,
      payload: null,
    });
    dispatch({
      type: RESET_DEVICE_SYNC_LOG,
      payload: [],
    });
    setSelectedDeviceDetails(dispatch, item);
    history?.push(ROUTES_CONSTANTS.deviceProfile);
  };

  return (
    <MainLayout
      text={titles?.devices_tracking}
      isBackHide={false}
      isNavbar={true}
      white={true}
      primary={true}
      isLoading={loading}
    >
      <div className="dat_container">
        {/* Subscriber Information Card */}
        <SubscriberInformationCard medicalUserDetail={selectedMedicalUser} />

        {/* Section Title */}
        <div className="dat_section_title">
          <h2 className="dat_title">{titles?.device_tracking}</h2>
        </div>

        {/* Device List */}
        <div className="dat_device_list">
          {deviceList?.map((item, index) => (
            <div key={`device-${index}`} className="dat_device_card">
              <div className="dat_device_image_container">
                <img
                  src={item?.image_url}
                  alt={item?.device_name}
                  className="dat_device_image"
                />
              </div>
              <div className="dat_device_info">
                <h3 className="dat_device_name">{item?.device_name}</h3>
                <p className="dat_device_subscriber">
                  {item?.subTitle || `${item?.firstname} ${item?.lastname}`}
                </p>
              </div>
              <div className="dat_device_action">
                <button
                  className="dat_see_device_btn"
                  onClick={() => onSeeDevicePress(item)}
                >
                  <RightFill width="32" height="32" />
                </button>
              </div>
            </div>
          ))}
        </div>
        {/* Empty State */}
        {deviceList?.length <= 0 && !loading && (
          <div className="dat_empty_state">
            <p className="dat_empty_text">{titles?.no_device_available}</p>
          </div>
        )}
      </div>
    </MainLayout>
  );
};

export default DeviceAndTracking;
